import { createContext, useContext } from 'react';
export var ListGroupContext = /*#__PURE__*/createContext({});
export var useListGroupContext = function () {
  return useContext(ListGroupContext);
};